<template>
  <div>
    <CRow>
      <div class="col-md-4 col-xs-12 col-sm-12 firstcol p-0">
        <CCard class="pt-0">
          <CCardBody>
            <div style="height: 753px; overflow-y: auto">
              <CCard class="p-0 m-0 border"> </CCard>
              <CCard class="col-sm-12 p-0">
                <CCardBody class="col-sm-12 p-0">
                  <semipolar-spinner
                    :animation-duration="2000"
                    :size="100"
                    color="blue"
                    v-if="firstColumnLoader"
                  ></semipolar-spinner>
                  <CListGroup accent v-else>
                    <CListGroupItem
                      href="#"
                      class="col-sm-12 p-1 pt-2 pb-2"
                      color="light"
                      v-for="(item, index) in channelLists"
                      :key="index"
                      accent="light"
                      @click="detailChannelInfo(item.id)"
                      :active="activeChannelIds == item.id ? true : false"
                    >
                      <div class="py-3 mfe-3 float-left">
                        <div class="c-avatar">
                          <img
                            class="c-avatar-img"
                            :src="getImage(item.image)"
                          /><span class="c-avatar-status bg-info"></span>
                        </div>
                      </div>
                      <div>
                        <CBadge
                          color="info float-right"
                          shape="pill"
                          style="padding: 10px; font-size: 15px"
                          >{{ item.message_unread_counter }}</CBadge
                        >
                      </div>
                      <div class="text-truncate font-weight-bold">
                        {{ item.display_name }}<br />
                        <CBadge
                          :color="item.is_chat ? 'info' : 'primary'"
                          shape="pill"
                          >{{ item.is_chat ? "Channel" : "Chat" }}</CBadge
                        >
                      </div>
                    </CListGroupItem>
                  </CListGroup>
                </CCardBody>
              </CCard>
            </div>
          </CCardBody>
        </CCard>
      </div>

      <div class="col-md-4 col-xs-12 col-sm-12 p-0">
        <CCard>
          <CCardBody class="pt-3">
            <div style="height: 645px; overflow-y: auto">
              <CRow class="p-0">
                <CListGroup class="col-md-12 p-3" name="reviews">
                  <semipolar-spinner
                    :animation-duration="2000"
                    :size="100"
                    color="blue"
                    v-if="secondColumnLoader"
                  ></semipolar-spinner>
                  <template v-else>
                    <div
                      class="message p-3"
                      v-if="secondColumnChannelData.length === 0"
                    >
                      No Reviews...
                    </div>

                    <CListGroupItem
                      href="#"
                      class="message col-sm-12 p-3 border-bottom"
                      v-for="(item, index) in secondColumnChannelData"
                      :key="index"
                    >
                      <div>
                        <div>
                          <div class="py-2 mfe-3 float-left">
                            <div
                              class="c-avatar"
                              style="width: 40px; height: 40px"
                            >
                              <img
                                class="c-avatar-img"
                                :src="`https://martech-api-staging.apachedigital.io${item.module_icon}`"
                                alt="user@email.com"
                              />
                              <!-- <span class="c-avatar-status bg-success"></span> -->
                            </div>
                            <!-- <div class="pl-3">
                              <i style="color: green" class="fas fa-star"></i>
                            </div> -->
                          </div>
                          <div class="col-sm-12">
                            <!-- <span class="text-muted float-right">
                              <i class="fa fa-star" aria-hidden="true"></i>
                            </span> -->

                            <!-- <span class="text-muted float-right mr-2">
                              {{ item.date }}
                            </span> -->
                          </div>
                          <div class="text-truncate font-weight-bold">
                            {{ item.email_from }}
                            <p>
                              <small>{{ item.date }}</small>
                            </p>
                          </div>
                          <!-- <div>
                            <small class="message">
                              Message
                            </small>
                            >
                          </div> -->
                          <div class="medium mt-3" v-html="item.body"></div>
                          <!-- <div class="col-sm-12 pb-4">
                            <CBadge color="light" class="float-right ml-2 p-2">
                              <i
                                class="fa fa-check text-muted"
                                aria-hidden="true"
                              ></i>
                              <i
                                class="fa fa-check text-primary"
                                aria-hidden="true"
                              ></i>
                            </CBadge>
                            <CBadge color="light" class="float-right p-2">
                              <i class="fa fa-heart" aria-hidden="true"></i>
                            </CBadge>
                          </div> -->
                        </div>
                      </div>
                    </CListGroupItem>
                  </template>
                </CListGroup>
              </CRow>
            </div>
          </CCardBody>
        </CCard>
      </div>

      <div class="col-md-4 col-xs-12 col-sm-12 p-0">
        <CCard class="pt-2">
          <CRow>
            <CCol class="col-12">
              <CCardBody>
                <CRow>
                  <semipolar-spinner
                    :animation-duration="2000"
                    :size="100"
                    color="blue"
                    v-if="thirdColumnLoader"
                  ></semipolar-spinner>
                  <template
                    v-if="
                      !thirdColumnLoader &&
                      !secondColumnLoader &&
                      secondColumnChannelData.length > 0
                    "
                  >
                    <div class="col-sm-12 pt-3">
                      <!-- <CInput placeholder="Answer should be here" name="input_answer" /> -->
                      <mdb-input
                        class="mb-3 mt-0"
                        placeholder="Answer should be here"
                        v-model="reply_text"
                        required
                      ></mdb-input>
                    </div>

                    <div class="col-sm-12 mt-2 pb-2">
                      <!-- <span class="float-left mr-2">
                      <CIcon name="cilCommentSquare"></CIcon>
                      </span>-->
                      <span class="float-left mr-2">
                        <emoji-picker @emoji="insert">
                          <!--  -->
                          <div
                            class="emoji-invoker"
                            slot="emoji-invoker"
                            slot-scope="{ events: { click: clickEvent } }"
                            @click.stop="clickEvent"
                          >
                            <CIcon name="cilSmile"></CIcon>
                          </div>

                          <div
                            slot="emoji-picker"
                            slot-scope="{ emojis, insert }"
                          >
                            <div class="emoji-picker">
                              <div class="emoji-picker__search">
                                <input type="text" v-model="search" v-focus />
                              </div>
                              <div>
                                <div
                                  v-for="(emojiGroup, category) in emojis"
                                  :key="category"
                                >
                                  <h5>{{ category }}</h5>
                                  <div class="emojis">
                                    <span
                                      v-for="(emoji, emojiName) in emojiGroup"
                                      :key="emojiName"
                                      @click="insert(emoji)"
                                      :title="emojiName"
                                      >{{ emoji }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </emoji-picker>
                      </span>
                      <span>
                        <button
                          class="btn btn-danger float-right pt-1 pb-1"
                          @click="sendMessage()"
                        >
                          Enviar
                        </button>
                        <!-- <CBadge
                          color="danger"
                          ></CBadge
                        > -->
                      </span>
                    </div>
                  </template>

                  <!--<div class="col-sm-6 pt-3">Mencionar en tu comentario</div>
                  <div class="col-sm-6 pt-3">
                    <span>
                      <CInputCheckbox label="Lluis Pascal" name="checkbox-1" />
                    </span>
                    </div>-->
                </CRow>
              </CCardBody>
            </CCol>
          </CRow>
        </CCard>
      </div>
    </CRow>
  </div>
</template>

<script >
// import MainChartExample from './charts/MainChartExample'
// import WidgetsDropdown from './widgets/WidgetsDropdown'
// import WidgetsBrand from './widgets/WidgetsBrand'
import store from "../../store";
// import XmlAjaxRequest from '../../store/GlobalAPiCall';
// import UrlMethods from '../../store/UrlMethods';

import { shuffleArray } from "@/shared/utils";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";
import moment from "moment";
import { mdbInput } from "mdbvue";
import EmojiPicker from "vue-emoji-picker";
// import VEmojiPicker from 'v-emoji-picker';
import { SemipolarSpinner } from "epic-spinners";
import Treeselect from "@riophae/vue-treeselect";
import Multiselect from "vue-multiselect";
import axios from "axios";
import ScrollLoader from "vue-scroll-loader";

// Vue.use(ScrollLoader)
import {
  mdbBtn,
  mdbIcon,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
} from "mdbvue";

export default {
  name: "Actions",
  components: {
    DatePicker,
    mdbInput,
    EmojiPicker,
    SemipolarSpinner,
    Treeselect,
    Multiselect,
    mdbBtn,
    mdbIcon,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
  },
  data() {
    return {
      open: false,
      firstColumnLoader: false,
      channelLists: [],
      activeChannelIds: 0,
      secondColumnLoader: false,
      secondColumnChannelData: [],
      thirdColumnLoader: false,
      thirdColumnChannelData: [],
      search: "",
      reply_text: "",
    };
  },
  mounted() {
    this.loadChannels();
  },
  methods: {
    async loadChannels() {
      this.channelLists = [];
      this.firstColumnLoader = true;
      await store.dispatch("getUserChannels").then((data) => {
        let userChannelData = store.getters.get_N_UserChannels.data;
        if (userChannelData.records) {
          userChannelData = userChannelData.records;
          this.channelLists = userChannelData;
          this.firstColumnLoader = false;
          this.activeChannelIds = this.channelLists[0]["id"];
          this.detailChannelInfo(this.activeChannelIds);
        }
      });
    },
    async detailChannelInfo(id) {
      this.activeChannelIds = id;
      this.secondColumnLoader = true;
      await store.dispatch("get_N_ChannelMessages", [id]).then((data) => {
        let userChannelData = store.getters.get_N_ChannelMessages.data;
        this.secondColumnLoader = false;
        this.secondColumnChannelData = userChannelData;
      });
    },
    insert(emoji) {
      this.reply_text += emoji;
    },
    getImage(image) {
      return `data:image/png;base64,${image}`;
    },

    async sendMessage() {
      this.thirdColumnLoader = true;
      const reqdata = {
        ids: [this.activeChannelIds],
        body: this.reply_text,
      };
      await store
        .dispatch("get_N_ChannelSendMessages", reqdata)
        .then((data) => {
          let sendMessageData = store.getters.get_N_ChannelSendMessages.data;
          this.thirdColumnLoader = false;
          this.thirdColumnChannelData = sendMessageData;
        });
    },
  },

  watch: {},
  color(value) {
    let $color;
    if (value <= 25) {
      $color = "info";
    } else if (value > 25 && value <= 50) {
      $color = "success";
    } else if (value > 50 && value <= 75) {
      $color = "warning";
    } else if (value > 75 && value <= 100) {
      $color = "danger";
    }
    return $color;
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!--<style>
  @import './assets/css/custom.css';
</style>-->
<style >
.tabnav .nav-link {
  display: block;
  padding: 0.5rem 5px;
  font-size: 12px;
}
.firstcol .card-body {
  padding: 10px 7px;
}

/* This demo uses Tailwind v0.6.4 */

/*
.emoji-invoker {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
}*/
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: #b1c6d0;
}

.emoji-picker {
  position: absolute;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 15rem;
  height: 20rem;
  overflow: scroll;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emoji-picker .emojis:after {
  content: "";
  flex: auto;
}
.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}
</style>